class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
    this.closeBtn = this.drawer.querySelector('.cart-drawer__close');
    this.itemsContainer = this.drawer.querySelector('.cart-drawer__items');
    this.subtotalEl = this.drawer.querySelector('.cart-drawer__subtotal-value');

    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-open]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
      this.updateCount(cart.item_count);
    } catch (err) {
      console.error('Cart refresh failed', err);
    }
  }

  render(cart) {
    if (!this.itemsContainer) return;

    if (cart.item_count === 0) {
      this.itemsContainer.innerHTML = `<p class="cart-drawer__empty">${window.themeSettings.strings.cartEmpty}</p>`;
      if (this.subtotalEl) this.subtotalEl.textContent = '$0.00';
      return;
    }

    this.itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item">
        <div class="cart-drawer__item-image">
          <img src="${item.image}" alt="${item.title}" width="70" height="70" loading="lazy">
        </div>
        <div>
          <div class="cart-drawer__item-title">${item.product_title}</div>
          <div class="cart-drawer__item-price">${this.formatMoney(item.final_line_price)} × ${item.quantity}</div>
        </div>
      </div>
    `).join('');

    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }
  }

  updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

class AjaxCart {
  constructor(drawer) {
    this.drawer = drawer;
    this.bindForms();
  }

  bindForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.js-ajax-cart');
      if (!form) return;

      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const res = await fetch(window.themeSettings.routes.cartAdd, {
          method: 'POST',
          body: formData
        });

        if (res.ok) {
          if (window.themeSettings.cartType === 'drawer' && this.drawer) {
            this.drawer.open();
          } else {
            window.location.href = window.themeSettings.routes.cartUrl;
          }
        }
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = window.themeSettings.strings.addToCart;
        }
      }
    });
  }
}

class MobileNav {
  constructor() {
    this.toggle = document.querySelector('[data-menu-toggle]');
    this.nav = document.querySelector('.nav-bar');
    if (!this.toggle || !this.nav) return;

    this.toggle.addEventListener('click', () => {
      this.nav.classList.toggle('is-open');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const drawer = new CartDrawer();
  new AjaxCart(drawer);
  new MobileNav();
});
